import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertyDuplicationsComponent } from './property-duplications.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [PropertyDuplicationsComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    MatProgressSpinnerModule
  ]
})
export class PropertyDuplicationsModule { }
